export const API_URL = process.env.REACT_APP_API_URL || '';

export const DOWNLOAD_DEFAULT_ERROR_MESSAGE = 'Error while downloading report';
export const DOWNLOAD_DEFAULT_SUCCESS_MESSAGE = 'Report generated successfully!';

export const MAX_LABEL_LENGTH = 50;

export const ROS_SITE_INFO_MESSAGE =
  'If you cannot find the site in this list, please contact your Ministry of Health contact to add it to the portal. Please hold off on tracking Return of Service in the meantime.';
